import FilterEdo from 'components/FilterEdo';
import FilterGroup from 'components/FilterGroup';
import FilterSlider from 'components/FilterSlider';
import FilterInputs from 'components/FilterInputs';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import Wrapper, { Cipher, Button } from './styles';
import { FilterTitle } from './styles';
import { ExpandedContainer, Des } from './styles';
import { useSwipeable, Swipeable } from 'react-swipeable'

const FilterDrawer = () => {
  const [active, setActive] = useState(false);
  const state = useSelector((reduxState) => reduxState.general);

  return(
    <Swipeable onSwipedLeft={() => setActive(true)} onSwipedRight={() => setActive(false)}>
    <Wrapper active={active} >
      <Button onClick={() => setActive(!active)} id="drawer-button"/>
      {
        active  ? (
        <ExpandedContainer>
          <Des>
            Personal de salud fallecido
          </Des>
          <Cipher>
            {state.particlesSize}
          </Cipher>
          <Des>
            Utiliza los filtros o muévete sobre las partículas para conocer a quienes han muerto durante la pandemia por Covid–19.
          </Des>
          <br/>
          <Des>
            Puedes seleccionar más de un filtro, para restaurarlos haz doble clic en alguno.
          </Des>
          <FilterGroup
            keyName="type" 
            data={[
              {
                name: 'Fotografías',
                value: 'photo'
              },
              {
                name: 'Semblanzas',
                value: 'Semblanza'
              },
              {
                name: 'Perfiles',
                value: 'Perfil'
              },
              {
                name: 'Todos',
                value: '*'
              }
            ]}
          />
          <FilterSlider />
          <FilterGroup
            keyName="gender" 
            data={[
              {
                name: 'Hombre',
                value: 'M'
              },
              {
                name: 'Mujer',
                value: 'F'
              },
              {
                name: 'Todos',
                value: '*'
              }
            ]}
          />
          <FilterGroup
            keyName="category" 
            exclude="S/D"
            autoGenerate
          />
          <FilterEdo />
          <FilterInputs />
          <Des>
            <a href="/murieron-por-nosotros.zip" target="_blank" style={{color: 'black'}}>
            Descargar base
            </a>
          </Des>
        </ExpandedContainer>
        )
        : 
        <FilterTitle>Filtros</FilterTitle>
      }
    </Wrapper>
    </Swipeable>
  ) 
}

export default FilterDrawer;